export default __webpack_public_path__ + "static/media/35.18899cd4.PNG";